import { render, staticRenderFns } from "./Questionnaire.html?vue&type=template&id=2089bad4&scoped=true&"
import script from "./Questionnaire.ts?vue&type=script&lang=ts&"
export * from "./Questionnaire.ts?vue&type=script&lang=ts&"
import style0 from "./Questionnaire.scss?vue&type=style&index=0&id=2089bad4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2089bad4",
  null
  
)

export default component.exports